export default __webpack_public_path__ + "static/media/google_play.d4a5eaa9.svg";